import angular from 'angular';

const noDirtyCheckDirective = /* @ngInject */ () => ({
	// Interacting with input elements having this directive won't cause the
	// form to be marked dirty.
	restrict: 'A',
	require:  'ngModel',
	link:     (scope, elm, attributes, ctrl) => {
		if ((attributes.noDirtyCheck && scope.$eval(attributes.noDirtyCheck) !== false) || !attributes.noDirtyCheck) {
			ctrl.$setDirty = angular.noop;
		}
	},
});

export default angular.module('app')
	.directive('noDirtyCheck', noDirtyCheckDirective);
